export const PATH = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  PROFILE: '/profile',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  DASHBOARD: '/dashboard',
  INCENTIVES_DASHBOARD: '/dashboard/incentives',
  PRODUCT_PLANNING_DASHBOARD: '/dashboard/product-planning',
  RECALL_COMPLIANCE_DASHBOARD: '/dashboard/recall-compliance',
  ADMIN_DASHBOARD: '/dashboard/admin',
};

export const MENUS = {
  INCENTIVES_DASHBOARD: 'incentives',
  PRODUCT_PLANNING_DASHBOARD: 'productPlanning',
  RECALL_COMPLIANCE: 'recallCompliance',
  ADMIN_DASHBOARD: 'admin',
};

export const ADMIN_MENU = [
  {
    label: 'INCENTIVES',
    value: MENUS.INCENTIVES_DASHBOARD,
    path: PATH.INCENTIVES_DASHBOARD,
  },
  {
    label: 'PRODUCT PLANNING',
    value: MENUS.PRODUCT_PLANNING_DASHBOARD,
    path: PATH.PRODUCT_PLANNING_DASHBOARD,
  },
  {
    label: 'RECALL COMPLIANCE',
    value: MENUS.RECALL_COMPLIANCE,
    path: PATH.RECALL_COMPLIANCE_DASHBOARD,
  },
  {
    label: 'ADMIN',
    value: MENUS.ADMIN_DASHBOARD,
    path: PATH.ADMIN_DASHBOARD,
  },
];

export const TEAMS = {
  ADMIN: 'admin',
  INCENTIVES: 'incentives',
  PRODUCT_PLANNING: 'productPlanning',
  RECALL_COMPLIANCE: 'recallCompliance',
  UNASSIGNED: 'unassigned',
};

export const ROLES = {
  ADMIN: 'admin',
  PUBLISHER: 'publisher',
  UAT_PUBLISHER: 'uat-publisher',
  SUPER_PUBLISHER: 'super-publisher',
  EDITOR: 'editor',
  PUBLISHER_AND_EDITOR: 'publisher-and-editor',
  UAT_PUBLISHER_AND_EDITOR: 'uat-publisher-and-editor',
  SUPER_PUBLISHER_AND_EDITOR: 'super-publisher-and-editor',
  VIEWER: 'viewer',
};

export const COGNITO_GROUPS = {
  ADMINS: 'Admins',
  PUBLISHER: 'Publisher',
  UAT_PUBLISHER: 'UATPublisher',
  SUPER_PUBLISHER: 'SuperPublisher',
  EDITOR: 'Editor',
  PUBLISHER_AND_EDITOR: 'PublisherAndEditor',
  UAT_PUBLISHER_AND_EDITOR: 'UATPublisherAndEditor',
  SUPER_PUBLISHER_AND_EDITOR: 'SuperPublisherAndEditor',
  VIEWER: 'Viewer',
};

export const roleOptions = [
  { label: 'Publisher', value: ROLES.PUBLISHER },
  { label: 'Editor', value: ROLES.EDITOR },
  { label: 'Viewer', value: ROLES.VIEWER },
];

export const BUILD_ENVS = { PROD: 'PROD', UAT: 'UAT', DEV: 'DEV' };

export const roleOptionsByBuildEnvAndTeam = {
  [BUILD_ENVS.DEV]: {
    [TEAMS.INCENTIVES]: [
      {
        label: 'Super Publisher & Editor',
        value: ROLES.SUPER_PUBLISHER_AND_EDITOR,
      },
      {
        label: 'DEV Publisher & Editor',
        value: ROLES.PUBLISHER_AND_EDITOR,
      },
      {
        label: 'UAT Publisher & Editor',
        value: ROLES.UAT_PUBLISHER_AND_EDITOR,
      },
      { label: 'Editor', value: ROLES.EDITOR },
      { label: 'Viewer', value: ROLES.VIEWER },
      { label: 'Super Publisher', value: ROLES.SUPER_PUBLISHER },
      {
        label: 'DEV Publisher',
        value: ROLES.PUBLISHER,
      },
      { label: 'UAT Publisher', value: ROLES.UAT_PUBLISHER },
    ],
    [TEAMS.PRODUCT_PLANNING]: [
      { label: 'Publisher & Editor', value: ROLES.PUBLISHER_AND_EDITOR },
      { label: 'Publisher', value: ROLES.PUBLISHER },
      { label: 'Editor', value: ROLES.EDITOR },
      { label: 'Viewer', value: ROLES.VIEWER },
    ],
    [TEAMS.RECALL_COMPLIANCE]: [
      { label: 'Super Publisher', value: ROLES.SUPER_PUBLISHER },
      { label: 'Viewer', value: ROLES.VIEWER },
    ],
    [TEAMS.ADMIN]: [],
    [TEAMS.UNASSIGNED]: [],
  },
  [BUILD_ENVS.UAT]: {
    [TEAMS.INCENTIVES]: [
      {
        label: 'Publisher & Editor',
        value: ROLES.PUBLISHER_AND_EDITOR,
      },
      { label: 'Editor', value: ROLES.EDITOR },
      { label: 'Viewer', value: ROLES.VIEWER },
      {
        label: 'Publisher',
        value: ROLES.PUBLISHER,
      },
    ],
    [TEAMS.PRODUCT_PLANNING]: [
      { label: 'Publisher & Editor', value: ROLES.PUBLISHER_AND_EDITOR },
      { label: 'Publisher', value: ROLES.PUBLISHER },
      { label: 'Editor', value: ROLES.EDITOR },
      { label: 'Viewer', value: ROLES.VIEWER },
    ],
    [TEAMS.RECALL_COMPLIANCE]: [
      { label: 'Super Publisher', value: ROLES.SUPER_PUBLISHER },
      { label: 'Viewer', value: ROLES.VIEWER },
    ],
    [TEAMS.ADMIN]: [],
    [TEAMS.UNASSIGNED]: [],
  },
  [BUILD_ENVS.PROD]: {
    [TEAMS.INCENTIVES]: [
      {
        label: 'Super Publisher & Editor',
        value: ROLES.SUPER_PUBLISHER_AND_EDITOR,
      },
      {
        label: 'PROD Publisher & Editor',
        value: ROLES.PUBLISHER_AND_EDITOR,
      },
      {
        label: 'UAT Publisher & Editor',
        value: ROLES.UAT_PUBLISHER_AND_EDITOR,
      },
      { label: 'Editor', value: ROLES.EDITOR },
      { label: 'Viewer', value: ROLES.VIEWER },
      { label: 'Super Publisher', value: ROLES.SUPER_PUBLISHER },
      {
        label: 'PROD Publisher',
        value: ROLES.PUBLISHER,
      },
      { label: 'UAT Publisher', value: ROLES.UAT_PUBLISHER },
    ],
    [TEAMS.PRODUCT_PLANNING]: [
      { label: 'Publisher & Editor', value: ROLES.PUBLISHER_AND_EDITOR },
      { label: 'Publisher', value: ROLES.PUBLISHER },
      { label: 'Editor', value: ROLES.EDITOR },
      { label: 'Viewer', value: ROLES.VIEWER },
    ],
    [TEAMS.RECALL_COMPLIANCE]: [
      { label: 'Super Publisher', value: ROLES.SUPER_PUBLISHER },
      { label: 'Viewer', value: ROLES.VIEWER },
    ],
    [TEAMS.ADMIN]: [],
    [TEAMS.UNASSIGNED]: [],
  },
};

export const teamOptions = [
  { label: 'Incentives', value: TEAMS.INCENTIVES },
  { label: 'Product planning', value: TEAMS.PRODUCT_PLANNING },
  { label: 'Recall Compliance', value: TEAMS.RECALL_COMPLIANCE },
  { label: 'Admin', value: TEAMS.ADMIN },
  { label: 'Unassigned', value: TEAMS.UNASSIGNED },
];

// mapping role value to cognito group
export const permissionsMap = {
  [ROLES.ADMIN]: COGNITO_GROUPS.ADMINS,
  [ROLES.PUBLISHER]: COGNITO_GROUPS.PUBLISHER,
  [ROLES.UAT_PUBLISHER]: COGNITO_GROUPS.UAT_PUBLISHER,
  [ROLES.SUPER_PUBLISHER]: COGNITO_GROUPS.SUPER_PUBLISHER,
  [ROLES.EDITOR]: COGNITO_GROUPS.EDITOR,
  [ROLES.PUBLISHER_AND_EDITOR]: COGNITO_GROUPS.PUBLISHER_AND_EDITOR,
  [ROLES.UAT_PUBLISHER_AND_EDITOR]: COGNITO_GROUPS.UAT_PUBLISHER_AND_EDITOR,
  [ROLES.SUPER_PUBLISHER_AND_EDITOR]: COGNITO_GROUPS.SUPER_PUBLISHER_AND_EDITOR,
  [ROLES.VIEWER]: COGNITO_GROUPS.VIEWER,
};

export const SELECTED_MENU_INITIAL_STATE = 'incentives';
export const AuthError = {
  usernameInvalid: 'Username should be either an email or a phone number.',
  passwordTooShort:
    'Password did not conform with policy: Password not long enough',
  userIsNotConfirmed: 'User is not confirmed.',
  incorrectUsernameOrPassword: 'Incorrect username or password.',
  userDoesNotExist: 'User does not exist.',
  cantResetPwdUserNotVerified:
    'Cannot reset password for the user as there is no registered/verified email or phone_number',
  unknownError: 'Unknown error.',
};

export const TEST_USERS = {
  UNREGISTERED: 'sysuser@topverse.com',
  REGISTERED: 'chandjen.ac@gmail.com',
  EMAIL_NOT_VERIFIED: 'testuser@testdomain.com',
};

export const TEST_PASSWORD = '12345678';

export const FILE_FORMATS = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const VALIDATION_MSG_TYPES = {
  WARN: 'WARN',
  ERROR: 'ERROR',
  PROGRESS: 'PROGRESS',
};

export const FILE_VALIDATION_SERVICE = {
  API: 'FileValidationService',
  PATHS: {
    GET_VALIDATION_MSGS_BY_GROUP: '/getValidationMsgsByGroup',
    CANCEL_VALIDATION: '/cancelValidation',
  },
};

export const FILE_GENERATION_SERVICE = {
  PATHS: {
    GENERATE_PCDF: '/generatePcdf',
    GENERATE_TAX_IMPORT_FILE: '/generateTaxImportFile',
    GENERATE_MVDF: '/generateMvdf',
    GENERATE_PRICE_GUIDE: '/generatePriceGuide',
    GENERATE_TOOLBOX: '/generateToolbox',
    GENERATE_VEHICLE_TECH_SPECS: '/generateVehicleTechSpecs',
    GENERATE_PFA: '/generatePfa',
    GENERATE_TOP_FEATURES: '/generateTopFeatures',
    GENERATE_FEATURES_GUIDE: '/generateFeaturesGuide',
  },
};

export const S3_BUCKET_SERVICE = {
  API: 'S3BucketService',
  PATHS: {
    GET_LAST_UPDATED_FILE_IN_FOLDER: '/getLastUpdatedFileInFolder',
    GET_FILE_VERSION_HISTORY: '/getFileVersionHistory',
    LIST_FILES_IN_S3_FOLDER: '/listFilesInS3Folder',
    DELETE_ALL_VERSIONS_OF_OBJECT: '/deleteAllVersionsOfObject',
    DELETE_LATEST_VERSION_OF_OBJECT: '/deleteLatestVersionOfObject',
    DOWNLOAD_OBJECT_VERSION: '/downloadObjectVersion',
    PUBLISH_TO_MIPULSE: '/publishToMipulse',
    PUBLISH_FILES_TO_MIPULSE_UAT: '/publishFilesToMipulseUAT',
    READ_CSV_DATA: '/readCSV',
  },
};

export const AUTH_SERVICE = {
  AUTHENTICATE: 'authenticate',
  SIGN_UP: 'signUp',
  LOGIN: 'login',
  LOGOUT: 'logout',
  FORGOT_PASSWORD: 'forgotPassword',
  FORGOT_PASSWORD_SUBMIT: 'forgotPasswordSubmit',
  RESEND_SIGN_UP: 'resendSignUp',
};

export const COGNITO_SERVICE = {
  API: 'AdminQueries',
  PATHS: {
    GET_ASSIGNED_MEMBERS: '/getAssignedMembers',
    GET_UNASSIGNED_MEMBERS: '/getUnassignedMembers',
    LIST_USERS: '/listUsers',
    LIST_USERS_IN_GROUP: '/listUsersInGroup',
    DELETE_USER: '/deleteUser',
    REMOVE_USER_FROM_GROUP: '/removeUserFromGroup',
    ADD_USER_TO_GROUP: '/addUserToGroup',
    UPDATE_USER_ATTRIBUTES: '/updateUserAttributes',
  },
};

export const VALIDATION_MSG_GROUP_IDS = {
  IMD: 'imd-processing',
  PPL: 'ppl-processing',
  PRICE_MATRIX: 'price-matrix-processing',
  TECH_SPECS: 'tech-specs-processing',
  NOMENCLATURE_GUIDE: 'nomenclature-guide-processing',
  VIN: 'vin-processing',
};

export const OUTPUT_FILES = {
  PCDF: 'pcdf',
  MVDF: 'mvdf',
  TAX_IMPORT: 'tax-import',
  TOOLBOX: 'toolbox',
  PFA: 'pfa',
  PRICE_GUIDE: 'price-guide',
  VEHICLE_TECH_SPECS: 'vehicle-tech-specs',
  FEATURES_GUIDE: 'features-guide',
  VIN: 'vin',
};

export const USER_FILE_ACTIONS = {
  GENERATE_PCDF: 'generate-pcdf',
  UPDATE_PCDF: 'update-pcdf',
  UPDATE_ALL_PCDFS: 'update-all-pcdfs',
  PUBLISH_PCDF: 'publish-pcdf',
  PUBLISH_ALL_PCDFS: 'publish-all-pcdfs',
  PUBLISH_TAX_IMPORT: 'publish-tax-import',
  PUBLISH_MVDF: 'publish-mvdf',
  PUBLISH_ALL_MVDFS: 'publish-all-mvdfs',
  GENERATE_TOOLBOX: 'generate-toolbox',
  UPDATE_TOOLBOX: 'update-toolbox',
  GENERATE_PFA: 'generate-pfa',
  UPDATE_PFA: 'update-pfa',
  GENERATE_PRICE_GUIDE: 'generate-price-guide',
  UPDATE_PRICE_GUIDE: 'update-price-guide',
  UPDATE_ALL_PRICE_GUIDES: 'update-all-price-guides',
  GENERATE_FEATURES_GUIDE: 'generate-features-guide',
  UPDATE_FEATURES_GUIDE: 'update-features-guide',
  UPDATE_ALL_FEATURES_GUIDES: 'update-all-features-guides',
  BULK_UPDATE_INCENTIVE_FILES_INCLUDING_PCDF:
    'bulk-update-incentive-files-including-pcdf',
  BULK_UPDATE_INCENTIVE_FILES_EXCLUDING_PCDF:
    'bulk-update-incentive-files-excluding-pcdf',
  BULK_PUBLISH_INCENTIVES_FILES: 'bulk-publish-incentives-files',
  BULK_PUBLISH_PRODUCT_PLANNING_FILES: 'bulk-publish-product-planning-files',
  BULK_UPDATE_PRODUCT_PLANNING_FILES: 'bulk-update-incentive-files',
  PUBLISH_VIN: 'publish-vin',
};

export const FILE_GENERATION_PARAMS_STORAGE_KEY = {
  PCDF_START_DATE: 'mmscan-pcdf-start-date',
  PCDF_END_DATE: 'mmscan-pcdf-end-date',
  PCDF_DATA_SET_ID: 'mmscan-pcdf-data-set-id',
};

export const S3_BUCKET = {
  // imd
  IMD_UPLOADS_FOLDER: 'imd/uploads',
  IMD_REPORTS_FOLDER: 'imd/reports',
  IMD_PROCESSED_FOLDER: 'imd/processed',
  IMD_OUTBOX_FOLDER: 'imd/outbox',
  IMD_REJECTED_FOLDER: 'imd/rejected',
  IMD_TEMP_VALIDATED_FOLDER: 'imd/temp/validated',
  IMD_TEMP_OUTBOX_FOLDER: 'imd/temp/outbox',
  // ppl
  PPL_UPLOADS_FOLDER: 'ppl/uploads',
  PPL_REPORTS_FOLDER: 'ppl/reports',
  PPL_PROCESSED_FOLDER: 'ppl/processed',
  PPL_OUTBOX_FOLDER: 'ppl/outbox',
  PPL_REJECTED_FOLDER: 'ppl/rejected',
  PPL_TEMP_VALIDATED_FOLDER: 'ppl/temp/validated',
  PPL_TEMP_OUTBOX_FOLDER: 'ppl/temp/outbox',
  // price matrix
  PRICE_MATRIX_UPLOADS_FOLDER: 'pricematrix/uploads',
  PRICE_MATRIX_REPORTS_FOLDER: 'pricematrix/reports',
  PRICE_MATRIX_PROCESSED_FOLDER: 'pricematrix/processed',
  PRICE_MATRIX_OUTBOX_FOLDER: 'pricematrix/outbox',
  PRICE_MATRIX_REJECTED_FOLDER: 'pricematrix/rejected',
  PRICE_MATRIX_TEMP_VALIDATED_FOLDER: 'pricematrix/temp/validated',
  PRICE_MATRIX_TEMP_OUTBOX_FOLDER: 'pricematrix/temp/outbox',
  // tech specs
  TECH_SPECS_UPLOADS_FOLDER: 'techspecs/uploads',
  TECH_SPECS_REPORTS_FOLDER: 'techspecs/reports',
  TECH_SPECS_PROCESSED_FOLDER: 'techspecs/processed',
  TECH_SPECS_OUTBOX_FOLDER: 'techspecs/outbox',
  TECH_SPECS_REJECTED_FOLDER: 'techspecs/rejected',
  TECH_SPECS_TEMP_VALIDATED_FOLDER: 'techspecs/temp/validated',
  TECH_SPECS_TEMP_OUTBOX_FOLDER: 'techspecs/temp/outbox',
  // nomenclature guide
  NOMENCLATURE_GUIDE_UPLOADS_FOLDER: 'nomenclatureguide/uploads',
  NOMENCLATURE_GUIDE_REPORTS_FOLDER: 'nomenclatureguide/reports',
  NOMENCLATURE_GUIDE_PROCESSED_FOLDER: 'nomenclatureguide/processed',
  NOMENCLATURE_GUIDE_OUTBOX_FOLDER: 'nomenclatureguide/outbox',
  NOMENCLATURE_GUIDE_REJECTED_FOLDER: 'nomenclatureguide/rejected',
  NOMENCLATURE_GUIDE_TEMP_VALIDATED_FOLDER: 'nomenclatureguide/temp/validated',
  NOMENCLATURE_GUIDE_TEMP_OUTBOX_FOLDER: 'nomenclatureguide/temp/outbox',
  // vin
  VIN_UPLOADS_FOLDER: 'vin/uploads',
  VIN_REPORTS_FOLDER: 'vin/reports',
  VIN_PROCESSED_FOLDER: 'vin/processed',
  VIN_OUTBOX_FOLDER: 'vin/outbox',
  VIN_REJECTED_FOLDER: 'vin/rejected',
  VIN_TEMP_VALIDATED_FOLDER: 'vin/temp/validated',
  VIN_TEMP_OUTBOX_FOLDER: 'vin/temp/outbox',
  // generated files
  TOOLBOX_GENERATED_FOLDER: 'toolbox/generated',
  // pfa
  PFA_GENERATED_FOLDER: 'pfa/generated',
  // pcdf
  PCDF_GENERATED_FOLDER: 'pcdf/generated',
  TAX_IMPORT_GENERATED_FOLDER: 'taximport/generated',
  MVDF_GENERATED_FOLDER: 'mvdf/generated',
  PRICE_GUIDE_GENERATED_FOLDER: 'priceguide/generated',
  VEHICLE_TECH_SPECS_GENERATED_FOLDER: 'consolidatedspecs/generated',
  TOP_FEATURES_GENERATED_FOLDER: 'topfeatures/generated',
  FEATURES_GUIDE_GENERATED_FOLDER: 'featuresguide/generated',

  MIPULSE_TAX_IMPORT_INBOX_TEST_FOLDER: 'test/taxes/inbox',
  MIPULSE_PCDF_INBOX_TEST_FOLDER: 'test/payment/inbox',
  MIPULSE_MVDF_INBOX_TEST_FOLDER: 'test/myu/inbox',
  MIPULSE_TAX_IMPORT_INBOX_FOLDER: 'taxes/inbox',
  MIPULSE_PCDF_INBOX_FOLDER: 'payment/inbox',
  MIPULSE_MVDF_INBOX_FOLDER: 'myu/inbox',
  MIPULSE_VIN_PUBLISHED_FOLDER: 'vin/published',

  PUBLISH_HISTORY_FOLDER: 'publish-history',
  PUBLISH_LOGS_PCDF_FOLDER: 'pcdf',
  PUBLISH_LOGS_MVDF_FOLDER: 'mvdf',
  PUBLISH_LOGS_TAX_IMPORT_FOLDER: 'tax-import',
  PUBLISH_LOGS_VIN_FOLDER: 'vin',
};

export const S3_BUCKET_ACTIONS = {
  GET: 'get',
  LIST: 'list',
  PUT: 'put',
  CANCEL: 'cancel',
  DOWNLOAD: 'download',
  COPY: 'copy',
  REMOVE: 'remove',
  UPLOAD_JSON: 'upload-json',
};

export const GENERATE_SECTION_DESCRIPTION =
  'Upload source documents to generate output files.';

export const LAST_PUBLISHED_VERSIONS_JSON_FILE = 'last-published-versions.json';
export const VIN_RECALL_DATA_FILE = 'recall-data.json';
export const VIN_RECALL_LOG_FILE = 'recall-log.json';

export const PUBLISH_STATUS = {
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
  PROCESSING: 'processing',
  DRAFT: 'draft',
  UNDER_REVIEW: 'under_review',
  REJECTED: 'rejected',
  SCHEDULED: 'scheduled',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
  ERROR: 'error',
};

export const PUBLISH_STATUS_LABELS = {
  [PUBLISH_STATUS.PROCESSING]: 'Publishing',
  [PUBLISH_STATUS.PUBLISHED]: 'Published',
  [PUBLISH_STATUS.REJECTED]: 'Failed to Publish',
};
